import React, { Component } from 'react';

export class PermissionDenied extends Component {
  render() {
    return (
      <div className="tc">
        <h1>You shall not pass</h1>
        <div className="mb2">Sorry, you don't have permission to access this page. Please, contact SI at si@take.net to solve it.</div>
        <img src={require('../../assets/images/youshallnotpass.png')} alt="You shall not pass"/>
      </div>
    )
  }
}